import store from   './store'
import request from './requests'

var utils = {

    //set the token to localStorage
    setLocalStorage(storageName, data) {
        localStorage.setItem(storageName, data);
    },

    setRedirectToLocalStorage(data) {
        localStorage.setItem('redirectToken', JSON.stringify(data));
    },

    // create book path
    containsPathToBook(path) {
        if (path !== undefined && path.substring(0, 4) !== 'http') {
            return   'https://static.eudoxus.gr/books/' + path
        } else {
            return path
        }
    },
    
    
    convertDateFromVueCalendar(date){//date should be in yyyy-MM-dd and output will be dd/MM/yyyy
        const splitFirstDate = date.split('-');
        
        const year = splitFirstDate[0].toString();
        const month = splitFirstDate[1].toString();
        const day = splitFirstDate[2].toString();
        
        return day + '/' + month + '/' + year;
    },

    convertDateForVueCalendar(date){//date should be in dd/MM/yyyy and output will be yyyy-MM-dd
        const splitFirstDate = date.split('/');
        
        const year = splitFirstDate[2].toString();
        const month = splitFirstDate[1].toString();
        const day = splitFirstDate[0].toString();
        
        return year + '-' + month + '-' + day;
    },

    // need format yyyy-MM-dd
    // returns 1 if 1st date is greater than 2nd date -1 if 2nd is greater than 1st and 0 if equal
    compareDates(firstdate, secondDate, format) {
        let splitFirstDate;
        let splitSecondDate;

        let firstDateYear;
        let firstDateMonth;
        let firstDateDay;
        let secondDateYear;
        let secondDateMonth;
        let secondDateDay;
        
        if(format==='yyyy-MM-dd'){
            splitFirstDate = firstdate.split('-');
            splitSecondDate = secondDate.split('-');
            
            firstDateYear = Number(splitFirstDate[0]);
            firstDateMonth = Number(splitFirstDate[1]);
            firstDateDay = Number(splitFirstDate[2]);
            secondDateYear = Number(splitSecondDate[0]);
            secondDateMonth = Number(splitSecondDate[1]);
            secondDateDay = Number(splitSecondDate[2]);
        }

        if(format==='dd/MM/yyyy'){
            splitFirstDate = firstdate.split('/');
            splitSecondDate = secondDate.split('/');
    
            firstDateYear = Number(splitFirstDate[2]);
            firstDateMonth = Number(splitFirstDate[1]);
            firstDateDay = Number(splitFirstDate[0]);
            secondDateYear = Number(splitSecondDate[2]);
            secondDateMonth = Number(splitSecondDate[1]);
            secondDateDay = Number(splitSecondDate[0]);
        }

        if(firstDateYear>secondDateYear){
            return +1;
        }
        else if(firstDateYear<secondDateYear){
            return -1;
        }
        else {
            if(firstDateMonth>secondDateMonth){
                return +1;
            }
            else if(firstDateMonth<secondDateMonth){
                return -1;
            }
            else{
                if(firstDateDay>secondDateDay){
                    return +1;
                }
                else if(firstDateDay<secondDateDay){
                    return -1;
                }
                else
                    return 0;
            }

        }

    },


    //get the token from localStorage
    getLocalStorage(storageName) {
        return localStorage.getItem(storageName);
    },

    // delete the token from localStorage
    deleteLocalStorage(storageName) {
        localStorage.removeItem(storageName);
    },


    downLoadPDFNewTab(response){
        let blob = new Blob([response.data], {
            type: "application/pdf"
        });

        let url = window.URL.createObjectURL(blob);
        window.open(url,"_blank")

        //window.URL.revokeObjectURL(url);
    },

    checkIfNotEmptyUndefinedOrNull(val){
        if(val === '' || val == null || val == undefined) {
            return false;
        }else {
            return true;
        }
    },

    removeTokenFromBrowser() {
        this.deleteLocalStorage('sup_token');
        store.commit('setHomePageInformation', {});
        store.commit('setLoginModal', true);
    },

    openErrorDialog(errorText) {
        var storeObj = {
            title: 'Σφάλμα!',
            text: errorText,
            color: 'error',
            class: 'white--text indianRed text-center justify-center'
        };
        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', storeObj);
    },

    createNavigationItem() {
        let  navigationItems;
        if(store.getters.homePageInformation.bookSupplier.type ==='Ministry') {
            navigationItems = [
                {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/', disabled: false},
                {id: 1, icon: 'mdi-chart-line', label: 'Όρια Παραγγελιών', link: '/orderLimits', disabled: false},
                {id: 2, icon: 'mdi-truck-fast', label: 'Παραγγελίες Βιβλίων', link: '/libraryOrders', disabled: false},
                {id: 3, icon: 'search', label: 'Αναζήτηση', link: '/search', disabled: false},
            ];
        }else{
            navigationItems = [
                {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/', disabled: false},
                {id: 1, icon: 'mdi-truck-fast', label: 'Παραγγελίες Βιβλίων', link: '/libraryOrders', disabled: false},
                {id: 2, icon: 'equalizer', label: 'Αναφορές', link: '/reports', disabled: false},
                {id: 3, icon: 'search', label: 'Αναζήτηση', link: '/search', disabled: false},
            ];
        }
        store.commit('setNavigationItems', navigationItems);
    },
    
    
    downLoadXLSX(response){
        let blob = new Blob([response.data], {
            // type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object
        
        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        a.download = response.headers.filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },

    downloadFile(response){
        let type = response.headers['content-type'];
        let filename = response.headers['filename'];
        let data = response.data;
        
        let blob = new Blob([data], {
            type:  type
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object
        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        // if(filename === '' || filename === null  || filename === undefined ){
        //     a.download = filename;
        // }else{
        //     a.download = filename;
        // }
        a.download = filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },
    
    setSuccessPopup(title, text){
        var errorProps = {
            title: title,
            text: text,
            color: 'teal',
            class: 'white--text teal text-center justify-center',
            icon:'success',
            successStyle:true
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },

    setErrorPopup(title, message){
        var errorProps = {
            title: title,
            text: message,
            color: 'indianRed',
            class: 'white--text indianRed text-center justify-center',
            icon:'error',
            successStyle:false
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },
    
    // # # # # GLOBAL RULES # # # #
    
    isBlank(str) {
        return (!str || /^\s*$/.test(str));
    },
    
    emailRules(v) {
        if (!v || v.trim().length === 0)
            return 'Το πεδίο είναι υποχρεωτικό';
        if(/[Α-Ωα-ωίϊΐόάέύϋΰήώ]+/.test(v))
            return 'Το e-mail δεν πρέπει να περιέχει ελληνικούς χαρακτήρες';
        if (!/.+@.+\..+/.test(v))
            return 'Το e-mail πρέπει να είναι έγκυρο';
        return true;
    },
    
    capitalGreeksRule(v){
        if(/^([Α-Ω]+( [Α-Ω]+)?)$/.test(v)){
            return true;
        }else{
            return 'Μόνο κεφαλαία ελληνικά.';
        }
    },
    
    onlyLatinCharsRule(v){
        if(/[Α-Ωα-ω]+/.test(v)){
            return 'Μόνο λατινικοί χαρακτήρες.';
        }else{
            return true;
        }
    },
    
    noSpacesRule(v){
        if(/\s+|\t+/.test(v)){
            return 'Χωρίς κενά.';
        }else{
            return true;
        }
    },
    
    atLeastOneNumberRule(v){
        if(/[0-9]+/.test(v)){
            return true;
        }else{
            return 'Τουλάχιστον 1 αρθμός';
        }
    },
    
    atLeastOneSymbolRule(v){
        if(/\W+/.test(v)){
            return true;
        }else{
            return 'Τουλάχιστον 1 σύμβολο';
        }
    },
    
    atLeastOneLatinUpperCaseLetterRule(v){
        if(/[A-Z]+/.test(v)){
            return true;
        }else{
            return 'Τουλάχιστον 1 κεφαλαίο γράμμα.';
        }
    },
    
    atLeastOneLatinLowerCaseLetterRule(v){
        if(/[a-z]+/.test(v)){
            return true
        }else{
            return 'Τουλάχιστον 1 πεζό γράμμα.';
        }
    },
    
    eightCharsLengthRule(v){
        if(v.toString().length<8){
            return 'Τουλάχιστον 8 χαρακτήρες.';
        }else{
            return true;
        }
    },
    
    requiredRuleTextbox (v) {
        if (v && typeof v === 'string' && v.trim() !== '') {
            return true;
        } else {
            return 'Το πεδίο είναι υποχρεωτικό';
        }
    },
    
    requiredRule(v) {
        if (!!v)
            return true;
        return 'Το πεδίο είναι υποχρεωτικό';
    },
    
    wholeNumberRule(v) {
        if(!(/^\d+$/.test(v))){
            return 'Θετικός ακέραιος αριθμός';
        }
        return true;
    },
    
    periodRequiredRule(v) {
        if (v=== 0 || v=== 1 || v=== 2)
            return true;
        return 'Το πεδίο είναι υποχρεωτικό';
    },
    
    englishOnlyRule(v){
        if (v) {
            if (/^[a-zA-Z]+$/.test(v)) {
                return true
            }
            return 'Μόνο αγγλικοί χαρακτήρες'
        }
        return true
    },
    
    
    mobilePhoneRule(v) {
        if (v) {
            if (/^(69[0-9]{8})$|(\+[0-9]{12})$/.test(v)) {
                return true
            }
            return 'Το τηλέφωνο δεν είναι έγκυρο'
        }
        return true
    },


    numbersAndNewLinesTest(v) {
        if (!v || v.trim().length === 0)
            return 'Το πεδίο είναι υποχρεωτικό';
        if (!/^([0-9]+\n)*[0-9]*$/.test(v))
            return 'Οι κωδικοί πρέπει να είναι αριθμοί, ο καθένας σε μια γραμμή';
        return true;
    },
    
    
};


export default utils
